import axios from "axios";
import { API } from "../../utils";
const instance = axios.create();

export const getBrands = async () => {
  return instance.get(`${API}/brand`);
};
